var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 5.77808,
    fill: "#C7ABDB",
    fillOpacity: 0.31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 24L24.9375 24.9565L26.875 25.913L29 29L29.375 35H21V24Z",
    fill: "#D2C0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 16C25 18.7614 22.9853 21 20.5 21C20.5 21 20.5 18.7614 20.5 16C20.5 13.2386 20.5 11.5 20.5 11C22.9853 11 25 13.2386 25 16Z",
    fill: "#D2C0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6562 22.0938C23.8615 22.0938 26.4688 19.4865 26.4688 16.2812C26.4688 13.076 23.8615 10.4688 20.6562 10.4688C17.451 10.4688 14.8438 13.076 14.8438 16.2812C14.8438 19.4865 17.451 22.0938 20.6562 22.0938ZM20.6562 12.4062C22.7929 12.4062 24.5312 14.1446 24.5312 16.2812C24.5312 18.4179 22.7929 20.1562 20.6562 20.1562C18.5196 20.1562 16.7812 18.4179 16.7812 16.2812C16.7812 14.1446 18.5196 12.4062 20.6562 12.4062ZM20.6562 23.0312C15.3144 23.0312 10.9688 27.2496 10.9688 32.5915L10.9688 35.1807C10.9688 35.7157 11.4025 36.1494 11.9375 36.1494H29.375C29.91 36.1494 30.3438 35.7157 30.3438 35.1807V32.5915C30.3438 27.2496 25.9981 23.0312 20.6562 23.0312ZM28.4062 34.2119H12.9062V32.5915C12.9062 28.3182 16.383 24.9688 20.6562 24.9688C24.9295 24.9688 28.4062 28.3182 28.4062 32.5915V34.2119ZM40.0312 24C40.0312 24.535 39.5975 24.9688 39.0625 24.9688H35.1875V28.8438C35.1875 29.3787 34.7537 29.8125 34.2188 29.8125C33.6838 29.8125 33.25 29.3787 33.25 28.8438V24.9688H29.375C28.84 24.9688 28.4062 24.535 28.4062 24C28.4062 23.465 28.84 23.0312 29.375 23.0312H33.25V19.1562C33.25 18.6213 33.6838 18.1875 34.2188 18.1875C34.7537 18.1875 35.1875 18.6213 35.1875 19.1562V23.0312H39.0625C39.5975 23.0312 40.0312 23.465 40.0312 24Z",
    fill: "#662D91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonMore);
export default __webpack_public_path__ + "static/media/personMore.a76a670b556fff58aaf426608050626e.svg";
export { ForwardRef as ReactComponent };